import React from "react";
import { graphql } from "gatsby";
import Section from "../components/Section";
import GlobalStyles from "../components/GlobalStyles";
import GlobalFonts from "../components/GlobalFonts";
import TestShell from "../components/testShell";
import { IS_TESTING } from "../config";

const IndexPage = ({ data }) => {
  const content = (
    <>
      <GlobalStyles />
      <GlobalFonts />
      <Section
        datoContentData={data.allDatoCmsBespokeStory.edges[0].node.content}
      />
    </>
  );

  return IS_TESTING ? <TestShell>{content}</TestShell> : content;
};

export default IndexPage;

export const query = graphql`
  query StoryQuery {
    allDatoCmsBespokeStory(
      filter: { id: { eq: "DatoCmsBespokeStory-aTa1R94USTiGZvzlLo0suQ-en" } }
    ) {
      edges {
        node {
          id
          title
          content {
            ... on DatoCmsKeyValuePair {
              key
              id
              content {
                ... on DatoCmsGallery {
                  id
                  items {
                    url
                    alt
                    title
                    video {
                      muxPlaybackId
                      mp4Url(exactRes: high)
                      thumbnailUrl
                    }
                    format
                    customData
                    width
                    height
                  }
                  internal {
                    type
                  }
                }
                ... on DatoCmsKeyValuePairNested {
                  key
                  id
                  content {
                    ... on DatoCmsImage {
                      id
                      moduleTitle
                      images {
                        image {
                          fluid {
                            aspectRatio
                            src
                            srcSet
                          }
                        }
                        imageMobile {
                          fluid {
                            aspectRatio
                            src
                            srcSet
                          }
                        }
                      }
                    }
                    ... on DatoCmsSvg {
                      id
                      svgLandscape {
                        url
                      }
                      svgPortrait {
                        url
                      }
                    }
                    ... on DatoCmsParagraph {
                      id
                      moduleTitle
                      text
                    }
                    ... on DatoCmsHeadline {
                      id
                      moduleTitle
                      text
                    }
                    ... on DatoCmsJsonInput {
                      id
                      json
                    }
                    ... on DatoCmsKeyValuePairNested {
                      key
                      id
                      content {
                        ... on DatoCmsImage {
                          id
                          moduleTitle
                          images {
                            image {
                              fluid {
                                aspectRatio
                                src
                                srcSet
                              }
                            }
                            imageMobile {
                              fluid {
                                aspectRatio
                                src
                                srcSet
                              }
                            }
                          }
                        }
                        ... on DatoCmsParagraph {
                          id
                          moduleTitle
                          text
                        }
                        ... on DatoCmsHeadline {
                          id
                          moduleTitle
                          text
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
